import "./App.css";
import React, {useEffect} from "react";
import {ApiDetails, KEY, loginState} from "./dummyData";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import Stack from "@mui/material/Stack";
import {NotificationContainer, NotificationManager,} from "react-notifications";
import "react-notifications/lib/notifications.css";
import Home from "./pages/Home/Home";
import Snackbar from "@mui/material/Snackbar";
import {Alert, useMediaQuery, useTheme, Box} from "@mui/material";
import Sidebar from "./components/sidebar/Sidebar";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
// import Topbar from "./components/topbar/Topbar";
import ReportIssue from "./pages/ReportIssue/ReportIssue";
import Message from "./pages/messages/Message";
import {fetchEventSource} from "@microsoft/fetch-event-source";
import CryptoJS from "crypto-js";
import LoginPage from "./components/authentication/LoginPage";
import LoginPageModern from "./components/authentication/LoginMordern";
import HomeModern from "./pages/Home/Home";
import MessageModern from "./pages/messages/MessagesModern";
import ProfilePage from "./pages/Profile/Profile";
import ViewTickets from "./pages/ReportIssue/ViewTickets";
import ReportIssueModernClaude from "./pages/ReportIssue/ReportIssueModernClaude";
import Topbar from "./components/topbar/Topbar";
import IDUploadPage from "./pages/IDupload/IDUploadPage";

function App() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md')); // Use 'md' breakpoint for tablet/mobile

    const [open, setOpen] = React.useState(loginState);
    const [backdrop, setBackDrop] = React.useState(null);
    const [message, setMessage] = React.useState("");
    const [severity, setSeverity] = React.useState();
    const [isLoggedIn, setLogin] = React.useState(false);
    const [sidebarOpen, setSidebarOpen] = React.useState(false); // For mobile sidebar toggle

    const openDialog = () => {
        console.log("Opening Dialog ... ");
    };

    const changeLogin = () => {
        setLogin(true);
        //updateViewTopBar(true);
    };

    const logout = () => {
        setLogin(false);
        localStorage.clear();
    };

    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpen(false);
    };

    const handleClick = (message) => {
        setMessage(message.text);
        setSeverity(message.type);
        setOpen(true);
    };

    const openBackDrop = (message) => {
        if (message === "open") {
            setBackDrop(
                <div
                    style={{
                        position: "absolute",
                    }}
                >
                    <Backdrop
                        sx={{color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1}}
                        open={true}
                        onClick={null}
                    >
                        <CircularProgress color="inherit"/>
                    </Backdrop>
                </div>
            );
        } else {
            setBackDrop();
        }
    };

    const [forceRefresh, setForceRefresh] = React.useState(false);
    const [changeDisplay, setChangeDisplay] = React.useState(() => () => {});
    const [connectionMade, setConnectionMade] = React.useState(false);

    // Toggle sidebar for mobile
    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    // SSE
    useEffect(() => {
        const fetchData = async () => {
            try {
                let details = CryptoJS.AES.decrypt(
                    localStorage.getItem("tenant_details"),
                    KEY
                );

                let originalText = details.toString(CryptoJS.enc.Utf8);

                await fetchEventSource(
                    ApiDetails +
                    "pegasus/visionary/sse/" +
                    new Map(
                        Object.entries(JSON.parse(originalText))
                    ).get("tenant_id"),
                    {
                        method: "GET",
                        headers: {
                            Accept: "text/event-stream",
                        },
                        onopen(res) {
                            if (res.ok && res.status === 200) {
                                setConnectionMade(true);
                                // console.log("Connection made ", res);
                            } else if (
                                res.status >= 400 &&
                                res.status < 500 &&
                                res.status !== 429
                            ) {
                                console.log("Client side error ", res);
                            }
                        },
                        onmessage(event) {
                            try {
                                let notifications = Array.from(JSON.parse(event.data));

                                notifications.map((notifi, index) => {
                                    let notification = new Map(Object.entries(notifi));
                                    if (notification.get("type") === "payment") {
                                        NotificationManager.success(
                                            "Payment of " +
                                            notification.get("amount").toLocaleString("en-US", {
                                                style: "currency",
                                                currency: "KSH",
                                            }) + " has been received",
                                            "Payment Received",
                                            3000
                                        );
                                        setTimeout(() => {
                                            window.location.reload(false)
                                        }, 3500);
                                    }
                                });
                            } catch (e) {
                                //Means the SSE message is a keep alive
                                // console.log(event.data);
                            }
                        },
                        onclose() {
                            console.log("Connection closed by the server retrying ... ");
                        },
                        onerror(err) {
                            console.log("There was an error from server", err);
                        },
                    }
                );
            } catch (e) {
            }
        };
        if (!connectionMade) {
            fetchData();
        }
    }, []);

    return (
        <div>
            <NotificationContainer/>
            <Stack spacing={2} sx={{width: "100%"}}>
                <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
                    <Alert
                        onClose={handleClose}
                        severity={severity}
                        sx={{width: "100%"}}
                    >
                        {message}
                    </Alert>
                </Snackbar>
            </Stack>
            {backdrop}

            <Box className="App" sx={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
                <Router>
                    {/* Sidebar Component */}
                    <Sidebar
                        changeDisplay={changeDisplay}
                        isMobile={isMobile}
                        sidebarOpen={sidebarOpen}
                        toggleSidebar={toggleSidebar}
                    />

                    {/* Main Content Area */}
                    <Box
                        component="main"
                        sx={{
                            flexGrow: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            overflow: 'hidden',
                            width: isMobile ? 'calc(100vw - 70px)' : 'calc(100vw - 240px)', // 70px for mobile, 240px for desktop
                            transition: theme.transitions.create(['margin', 'width'], {
                                easing: theme.transitions.easing.sharp,
                                duration: theme.transitions.duration.leavingScreen,
                            }),
                        }}
                    >
                        {/* Topbar */}
                        <Box sx={{
                            flexShrink: 0,
                            zIndex: theme.zIndex.appBar,
                            borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
                        }}>
                            <Topbar
                                changeDisplay={changeDisplay}
                                isMobile={isMobile}
                                toggleSidebar={toggleSidebar}
                            />
                        </Box>

                        {/* Page Content */}
                        <Box
                            sx={{
                                flexGrow: 1,
                                overflow: 'auto',
                                backgroundColor: '#f5f5f5',
                                position: 'relative'
                            }}
                        >
                            <Routes>
                                <Route
                                    path="/"
                                    element={
                                        <LoginPageModern
                                            snackBar={(message) => handleClick(message)}
                                            fn={() => changeLogin()}
                                            refresh={(value) => {
                                                setForceRefresh(value);
                                            }}
                                        />
                                    }
                                />
                                <Route
                                    path="/home"
                                    element={
                                        <HomeModern
                                            loginState={isLoggedIn}
                                            topBar={() => changeLogin()}
                                            snackBar={(message) => handleClick(message)}
                                        />
                                    }
                                />
                                <Route
                                    path="/verify/account"
                                    element={
                                        <IDUploadPage
                                            loginState={isLoggedIn}
                                            topBar={() => changeLogin()}
                                            snackBar={(message) => handleClick(message)}
                                        />
                                    }
                                />
                                <Route
                                    path="/tickets"
                                    element={
                                        <ViewTickets
                                            loginState={isLoggedIn}
                                            topBar={() => changeLogin()}
                                            snackBar={(message) => handleClick(message)}
                                        />
                                    }
                                />
                                <Route
                                    path="/tickets/new"
                                    element={
                                        <ReportIssueModernClaude
                                            loginState={isLoggedIn}
                                            topBar={() => changeLogin()}
                                            snackBar={(message) => handleClick(message)}
                                        />
                                    }
                                />
                                <Route
                                    path="/messages"
                                    element={
                                        <MessageModern
                                            loginState={isLoggedIn}
                                            topBar={() => changeLogin()}
                                            snackBar={(message) => handleClick(message)}
                                        />
                                    }
                                />
                                <Route
                                    path="/profile"
                                    element={
                                        <ProfilePage
                                            loginState={isLoggedIn}
                                            topBar={() => changeLogin()}
                                            snackBar={(message) => handleClick(message)}
                                        />
                                    }
                                />
                            </Routes>
                        </Box>
                    </Box>
                </Router>
            </Box>
        </div>
    );
}

export default App;